module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addBlocked($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Wall:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "wall_id"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Click to select a wall",
      "options": _vm.walls
    },
    model: {
      value: (_vm.wallId),
      callback: function($$v) {
        _vm.wallId = $$v
      },
      expression: "wallId"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                From this day:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "starttime_date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "required": "",
      "type": "date",
      "placeholder": "Click to select a start day"
    },
    model: {
      value: (_vm.starttime.date),
      callback: function($$v) {
        _vm.$set(_vm.starttime, "date", $$v)
      },
      expression: "starttime.date"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                From this timeslot:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "starttime_time"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      "placeholder": "Click to select a start timeslot"
    },
    model: {
      value: (_vm.starttime.time),
      callback: function($$v) {
        _vm.$set(_vm.starttime, "time", $$v)
      },
      expression: "starttime.time"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                To this day:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "endtime_date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "required": "",
      "type": "date",
      "placeholder": "Click to select an end day:"
    },
    model: {
      value: (_vm.endtime.date),
      callback: function($$v) {
        _vm.$set(_vm.endtime, "date", $$v)
      },
      expression: "endtime.date"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                To this timeslot:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "endtime_time"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      },
      "placeholder": "Click to select a end timeslot"
    },
    model: {
      value: (_vm.endtime.time),
      callback: function($$v) {
        _vm.$set(_vm.endtime, "time", $$v)
      },
      expression: "endtime.time"
    }
  })], 1)]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Reason:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "reason"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blocked.reason),
      expression: "blocked.reason"
    }],
    attrs: {
      "name": "",
      "placeholder": "Add a reason why you block these timeslots",
      "type": "text"
    },
    domProps: {
      "value": (_vm.blocked.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blocked, "reason", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Block new timeslots\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn_blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Block timeslots\n            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c8a4c73", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c8a4c73","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blocked/AddBlocked.vue
// module id = 424
// module chunks = 1